module.exports = __webpack_public_path__ + "static/media/paper-plane-black.7f40cbee.svg";